import { render } from "./StudentPracticumAttendance.vue?vue&type=template&id=6327b9ca"
import script from "./StudentPracticumAttendance.vue?vue&type=script&lang=js"
export * from "./StudentPracticumAttendance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__